import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { fadeInOut } from '@helpers/fadeInOut';
import { OpsAlarmHistoryComponent } from './ops-alarm-history/ops-alarm-history.component';
import { OpsAlarmMonitoringComponent } from './ops-alarm-monitoring/ops-alarm-monitoring.component';
import { OpsOperationsComponent } from './ops-operations/ops-operations.component';
import { OpsAlarmsPageService } from '@service/ops-alarms/ops-alarm.service';
import { Subscription } from 'rxjs';
import { ResponsiveService } from '@service/responsive.service';
import { ScreenSizeType } from '@models/responsive';

export enum OpsAlarmChild {
    Monitoring = 'Monitoring',
    History = 'History',
    Operations = 'Operations',
}
@Component({
    selector: 'app-ops-alarm',
    templateUrl: './ops-alarm.component.html',
    styleUrls: ['./ops-alarm.component.scss'],
    animations: [fadeInOut],
    standalone: false
})
export class OpsAlarmComponent implements OnInit, OnDestroy {
    @ViewChild('monitoring') monitoring: TemplateRef<OpsAlarmMonitoringComponent>;
    @ViewChild('history') history: TemplateRef<OpsAlarmHistoryComponent>;
    @ViewChild('operations') operations: TemplateRef<OpsOperationsComponent>;
    @ViewChild('childContainer') childContainer: ElementRef;

    selectedTemplate: TemplateRef<any>;
    selectedLabel: string = OpsAlarmChild.Monitoring;
    currentLocation: string = '';
    selectedTemplateSubscription: Subscription;

    constructor(
        private opsAlarmsPageService: OpsAlarmsPageService,
        public responsive: ResponsiveService,
    ) {}

    ngOnInit(): void {
        this.selectedTemplateSubscription = this.opsAlarmsPageService.openAlarmMonitoring.subscribe(
            () => {
                this.selectedTemplate = this.monitoring;
                this.selectedLabel = OpsAlarmChild.Monitoring;
            },
        );
    }

    ngOnDestroy(): void {
        this.selectedTemplateSubscription?.unsubscribe();
    }

    getOpsAlarmChild() {
        return Object.values(OpsAlarmChild);
    }

    selectTemplate(templateNumber: number) {
        if (templateNumber === 1) {
            this.selectedTemplate = this.monitoring;
            this.selectedLabel = OpsAlarmChild.Monitoring;
        } else if (templateNumber === 2) {
            this.selectedTemplate = this.history;
            this.selectedLabel = OpsAlarmChild.History;
        } else if (templateNumber === 3) {
            this.selectedTemplate = this.operations;
            this.selectedLabel = OpsAlarmChild.Operations;
        } else {
            this.selectedTemplate = undefined;
            this.selectedLabel = OpsAlarmChild.Monitoring;
        }
    }

    backToTop(){
        this.childContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
